import { graphql } from "relay-runtime"

export const PatientFileLockFragment = graphql`
  fragment PatientFileLockFragment on PatientFileLock {
    id
    patientId
    lockedBy
    lockedAt
    lockRequestedAt
    lockRequestedBy
    inContextOfAppointment: appointment {
      id
    }
    requestInContextOfAppointmentId
  }
`

export const PatientFileLockFragmentInline = graphql`
  fragment PatientFileLockFragmentInline on PatientFileLock @inline {
    id
    patientId
    lockedBy
    lockedAt
    lockRequestedAt
    lockRequestedBy
    inContextOfAppointment: appointment {
      id
    }
    requestInContextOfAppointmentId
  }
`
